import moment from 'moment';

const filterMixin = {
  data() {
    return {
      filterOptionValues: {
        equal: '=',
        notEqual: '!=',
        less: '<',
        lessOrEqual: '<=',
        greater: '>',
        greaterOrEqual: '>=',
        contains: '*',
        startsWith: '^',
        endsWith: '$',
        notContain: '!*',
        similar: '~',
        from: 'from',
        to: 'to',
      },
      fieldValues: {
        primaryKey: 'primaryKey',
        text: 'text',
        wholeNumber: 'wholeNumber',
        decimalNumber: 'decimalNumber',
        floatNumber: 'floatNumber',
        boolean: 'boolean',
        dateTime: 'dateTime',
        date: 'date',
        lookup: 'lookup',
        recordStatus: 'recordStatus',
        parentChildHierarchy: 'parentChildHierarchy',
        selectColumn: 'selectColumn',
        createdDate: 'createdDate',
        lastUpdatedDate: 'lastUpdatedDate',
        lastUpdatedBy: 'lastUpdatedBy',
        ai: 'ai',
      },
    };
  },
  methods: {
    hierarchyFilter(filteredField, uploadField, field) {
      const hierarchyField = field.data.options.hierarchyField;
      return filteredField.selectItems.findIndex((elem) => [elem[hierarchyField.primary.name], elem[hierarchyField.display.name]].includes(uploadField)) > -1;
    },
    lookupFilter(filteredField, uploadField) {
      return filteredField.selectItems.findIndex((elem) =>  [elem.id, elem.text].includes(uploadField)) > -1;
    },
    booleanFilter(filteredField, uploadField) {
      return parseInt(filteredField.selected) === -1 ? true : !!parseInt(filteredField.selected) === uploadField;
    },
    numberFilter(filteredField, uploadField) {
      return !(!this.equal(filteredField, uploadField) ||
        !this.doesNotEqual(filteredField, uploadField) ||
        !this.less(filteredField, uploadField) ||
        !this.greater(filteredField, uploadField) ||
        !this.lessOrEqual(filteredField, uploadField) ||
        !this.greaterOrEqual(filteredField, uploadField));
    },
    statusFilter(filteredField, uploadField) {
      const status = filteredField['selectedStatus'];
      if (status.length > 0) {
        return status.includes(uploadField);
      }
    },
    textFilter(filteredField, uploadField) {
      return !(!this.equal(filteredField, uploadField) ||
        !this.doesNotEqual(filteredField, uploadField) ||
        !this.contains(filteredField, uploadField) ||
        !this.doesNotContain(filteredField, uploadField) ||
        !this.startWith(filteredField, uploadField) ||
        !this.endWith(filteredField, uploadField));
    },
    dateFilter(filteredField, uploadField) {
      if (uploadField) {
        const dateFormat = moment(uploadField).format('YYYY-MM-DD');

        if (filteredField.fromDate && filteredField.toDate) {
          if (!(filteredField.fromDate <= dateFormat && filteredField.toDate >= dateFormat)) {
            return false;
          }
        } else if (filteredField.fromDate) {
          if (!(filteredField.fromDate <= dateFormat)) {
            return false;
          }
        } else if (filteredField.toDate) {
          if (!(filteredField.toDate >= dateFormat)) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    formatDecimalValue(value) {
      return value.replace(/,/g, '');
    },
    formatNumberValue(value) {
      return value.replace(/[,.]/g, '');
    },
    equal(e, uploadField) {
      if (!uploadField && uploadField !== 0) {
        return false;
      }
      if (e.type === this.filterOptionValues.equal) {
        if (e.fieldType === this.fieldValues.text) {
          return uploadField.toLowerCase() === e.text.toLowerCase();
        }
        if (e.fieldType === this.fieldValues.wholeNumber) {
          return uploadField === parseInt(this.formatNumberValue(e.text));
        }
        if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
          return uploadField === parseFloat(this.formatDecimalValue(e.text));
        }
      }
      return true;
    },
    doesNotEqual(e, uploadField) {
      if (e.type === this.filterOptionValues.notEqual) {
        if (e.fieldType === this.fieldValues.text) {
          return uploadField.toLowerCase() !== e.text.toLowerCase();
        }
        if (e.fieldType === this.fieldValues.wholeNumber) {
          return uploadField === parseInt(this.formatNumberValue(e.text));
        }
        if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
          return uploadField !== parseFloat(this.formatDecimalValue(e.text));
        }
      }
      return true;
    },
    less(e, uploadField) {
      if (e.fieldType === this.fieldValues.wholeNumber) {
        return !(e.type === this.filterOptionValues.less && !(uploadField < parseInt(this.formatNumberValue(e.text))));
      }
      if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
        return !(e.type === this.filterOptionValues.less && !(uploadField < parseFloat(this.formatDecimalValue(e.text))));
      }
    },
    lessOrEqual(e, uploadField) {
      if (e.fieldType === this.fieldValues.wholeNumber) {
        return !(e.type === this.filterOptionValues.lessOrEqual && !(uploadField <= parseInt(this.formatNumberValue(e.text))));
      }
      if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
        return !(e.type === this.filterOptionValues.lessOrEqual && !(uploadField <= parseFloat(this.formatDecimalValue(e.text))));
      }
    },
    greater(e, uploadField) {
      if (e.fieldType === this.fieldValues.wholeNumber) {
        return !(e.type === this.filterOptionValues.greater && !(uploadField > parseInt(this.formatNumberValue(e.text))));
      }
      if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
        return !(e.type === this.filterOptionValues.greater && !(uploadField > parseFloat(this.formatDecimalValue(e.text))));
      }
    },
    greaterOrEqual(e, uploadField) {
      if (e.fieldType === this.fieldValues.wholeNumber) {
        return !(e.type === this.filterOptionValues.greaterOrEqual && !(uploadField >= parseInt(this.formatNumberValue(e.text))));
      }
      if (e.fieldType === this.fieldValues.decimalNumber || e.fieldType === this.fieldValues.floatNumber) {
        return !(e.type === this.filterOptionValues.greaterOrEqual && !(uploadField >= parseFloat(this.formatDecimalValue(e.text))));
      }
    },
    contains(e, uploadField) {
      return !(e.type === this.filterOptionValues.contains && !uploadField.toLowerCase().includes(e.text.toLowerCase()));
    },
    doesNotContain(e, uploadField) {
      return !(e.type === this.filterOptionValues.notContain && uploadField.toLowerCase().includes(e.text.toLowerCase()));
    },
    startWith(e, uploadField) {
      return !(e.type === this.filterOptionValues.startsWith && !uploadField.toLowerCase().startsWith(e.text.toLowerCase()));
    },
    endWith(e, uploadField) {
      return !(e.type === this.filterOptionValues.endsWith && !uploadField.toLowerCase().endsWith(e.text.toLowerCase()));
    },
  },
};

export default filterMixin;
